import gql from 'graphql-tag';

export const ReprocessFormResponse = gql`
  mutation ReprocessFormResponse($organizationId: ID!, $formResponseId: ID!) {
    reprocessFormResponse(organizationId: $organizationId, formResponseId: $formResponseId)
  }
`;
